export const overrideData = {
  //sweep angle
  sweepAngle: {
    //1PN
    '691d61359d4e2e854cdaf432': [
      { sceneId: '691c21599d4e2e854cda4544', defaultRotation: 6.2 },
      { sceneId: '691c215d9d4e2e854cda4560', defaultRotation: 6.9 },
      {
        sceneId: '691c215b9d4e2e854cda4553',
        defaultRotation: 1.7,
      },
    ],

    //2PN
    '691d61b69d4e2e854cdaf4d4': [
      { sceneId: '691c22439d4e2e854cda4844', defaultRotation: 1.5 },
      { sceneId: '691c2b769d4e2e854cda579a', defaultRotation: 6.2 },
      { sceneId: '691c2b749d4e2e854cda578f', defaultRotation: 1.5 },
    ],

    //3PN
    '691d5fa49d4e2e854cdaf20a': [
      { sceneId: '691c269d9d4e2e854cda4f82', defaultRotation: 1.6 },
      //balcony
      { sceneId: '691c2bc69d4e2e854cda5839', defaultRotation: 4.4 },
      { sceneId: '691c268a9d4e2e854cda4f50', defaultRotation: 2.8 },
      //bed
      { sceneId: '691c26969d4e2e854cda4f77', defaultRotation: 0.6 },
 
    ],
  },

  //scene hotspots
  outDoorJumpSpots: [
    '691c1bc39d4e2e854cda3edb',
    '68f9d3773294b0149d4685ba',

    //outdoor amenities
    '691d74719d4e2e854cdb0f56',
    '691d77749d4e2e854cdb1599',
    '691d72de9d4e2e854cdb0d02',
    '691d75019d4e2e854cdb102b',
  ],

  sceneFlycamOutdoorSpots: [
    '68d12cca208f82c724e17eb7',
    '68d12e81208f82c724e18004',
  ],

  //media hotspots
  internalAreaHotspots: [
    '68fb02e7e62230d4b445441b',
    '68fb00d0e62230d4b44541ac',
    '68fb00c3e62230d4b4454193',
    '68fb00b9e62230d4b445417f',
    '68fb0303e62230d4b4454459',
    '68fb02f3e62230d4b445443c',
    '6903592c085ec50c650870ca',
  ],

  amenitiesScenes: [
    '691d74719d4e2e854cdb0f56',
    '691d77749d4e2e854cdb1599',
    '691d72de9d4e2e854cdb0d02',
    '691d75019d4e2e854cdb102b',
  ],

  outDoorHotspots: [
    '691d74719d4e2e854cdb0f56',
    '691d77749d4e2e854cdb1599',
    '691d72de9d4e2e854cdb0d02',
  ],

  mediaHeights: [
    {
      mediaId: '68f9e8033294b0149d46977a',
      height: 1.5,
    },
  ],

  darkStyleHotspots: ['68f9da7e3294b0149d468bbf', '68f9db2e3294b0149d468ce6'],

  sceneTitle: [
    {
      sceneId: '68d1318e208f82c724e18089',
      title: 'Tầng 5',
    },
    {
      sceneId: '68d23c51208f82c724e1b8e3',
      title: 'Tầng 10',
    },
    {
      sceneId: '68d11fb3f1fff2aa8e505189',
      title: 'Tầng 15',
    },
    {
      sceneId: '68d11ff8f1fff2aa8e505326',
      title: 'Tầng 20',
    },
    {
      sceneId: '68d12016f1fff2aa8e50534e',
      title: 'Tầng 25',
    },
    {
      sceneId: '68d12769ddcbe92b6b39ad9e',
      title: 'Tầng 30',
    },
    {
      sceneId: '68d12cca208f82c724e17eb7',
      title: 'Toàn Cảnh 1',
    },
    {
      sceneId: '68d12e81208f82c724e18004',
      title: 'Toàn Cảnh 2',
    },
  ],
};

export const applyOverrideData = (json) => {
  if (!json || !Array.isArray(json.scenes)) return;

  const {
    outDoorJumpSpots,
    sceneFlycamOutdoorSpots,
    sceneTitle,
    outDoorHotspots,
    internalAreaHotspots,
    darkStyleHotspots,
    mediaHeights,
    amenitiesScenes,
    sweepAngle,
  } = overrideData;

  const outdoorIds = new Set(outDoorJumpSpots);
  const flycamIds = new Set(sceneFlycamOutdoorSpots);
  const outDoorHotspotIds = new Set(outDoorHotspots);
  const internalAreaHotspotIds = new Set(internalAreaHotspots);
  const darkStyleHotspotIds = new Set(darkStyleHotspots);
  const amenitiesSceneIds = new Set(amenitiesScenes);
  const mediaHeightMap = new Map(
    mediaHeights.map((item) => [item.mediaId, item.height])
  );

  const titleMap = new Map(
    sceneTitle.map((item) => [item.sceneId, item.title])
  );

  json.scenes.forEach((scene) => {
    if (outdoorIds.has(scene._id)) {
      scene.outdoorScene = true;
    }
    if (flycamIds.has(scene._id)) {
      scene.flycamOutdoorScene = true;
    }
    if (amenitiesSceneIds.has(scene._id)) {
      scene.amenitiesScene = true;
    }
    if (titleMap.has(scene._id)) {
      scene.amenitiesScene = true;
    }

    if (internalAreaHotspotIds.has(scene._id)) {
      scene.areaType = 'internalArea';
    }
  });

  json.media.forEach((media) => {
    if (outDoorHotspotIds.has(media._id)) {
      media.outDoorHotspot = true;
    }

    if (internalAreaHotspotIds.has(media._id)) {
      media.areaType = 'internalArea';
    }

    if (darkStyleHotspotIds.has(media._id)) {
      media.darkStyle = true;
    }

    if (mediaHeightMap.has(media._id)) {
      media.height = mediaHeightMap.get(media._id);
    }

    // Attach sweepAngle data by media id if configured (concise, no nested loops)
    if (sweepAngle && typeof sweepAngle === 'object') {
      const objects = media?.mapFloorPlan?.[0]?.objects;
      const list = sweepAngle[media._id];
      if (objects && Array.isArray(list) && list.length > 0) {
        const objectById = objects.reduce((acc, obj) => {
          acc[obj.id] = obj;
          return acc;
        }, {});
        list.forEach(({ sceneId, defaultRotation }) => {
          const target = objectById[sceneId];
          if (target) target.defaultRotation = defaultRotation;
        });
      }
    }
  });

  if (Array.isArray(json.menu)) {
    json.menu.forEach((menuGroup) => {
      if (Array.isArray(menuGroup.scenes)) {
        menuGroup.scenes.forEach((menuScene) => {
          if (titleMap.has(menuScene._id)) {
            menuScene.title = titleMap.get(menuScene._id);
          }
        });
      }
    });
  }
};

export default applyOverrideData;
